/* eslint-disable camelcase,max-statements,consistent-return,no-invalid-this */
import moment from "moment";

class Comment {
	constructor({
		id,
		text,
		created,
		author
	} = {}) {
		this._id = id;
		this._text = text || null;
		this._created = created ? moment(created) : null;
		this._author = author || null;
	}

    getId = () => this._id;

	getKey = () => String(this._id);

	getText = () => this._text;

	getDate = () => this._created;

	getAuthor = () => this._author;

}

export default Comment;
